import { isServiceError } from '../isServiceError';
import { isDataFetchingError } from '../DataFetchingError';

/**
 * Filter to prevent logging errors that are due to a request timeout,
 * since these are expected and not actionable.
 */
export class RequestTimeoutFilter {
  constructor() {
    this.messages = ['Request timeout', 'Request aborted'];
  }
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    if (!isServiceError(cause) && !isDataFetchingError(cause)) {
      return true;
    }
    if (isDataFetchingError(cause)) {
      return !this.messages.includes(cause.extra.cause.statusText);
    }
    return !this.messages.includes(cause.error.statusText);
  }
}